import React from 'react'
import { graphql, Link} from 'gatsby'
import { RichText} from 'prismic-reactjs'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './about.css'

export const query = graphql `
query 
{  
    allPrismicAbout { 
        edges { 
            node {  
              type 
              url
              data { 
                about_summary {
                    raw
                }
                info_sections {
                  section_title 
                  section_text {
                      raw
                  }
                }
                staff_group {
                  unit_name
                  staff_list {
                      raw
                  }
                  display_order
                  display_column
                }
              }                  
            } 
        } 
    }
}
`


const About = (props) => {
    const aboutPageInfo = props.data.allPrismicAbout.edges[0].node.data;
    const staffLeftColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Left").sort((g1, g2) => g1.display_order - g2.display_order);
    const staffRightColumn = aboutPageInfo.staff_group.filter(group => group.display_column === "Right").sort((g1, g2) => g1.display_order - g2.display_order);
    if (typeof window !== "undefined"){
        return (
        <Layout>
            <SEO title="About the Research Division" description="General information about the Research Division" pathname={props.location.pathname}/>
            <Row>
                <Col lg={9} className="text-left">
                    <h1>About the Research Division</h1> 
                </Col>
                <Col lg={3} className="text-lg-right pr-lg-3 pt-2 pt-lg-0">
                <p className="h5 font-weight-bold">Other Options</p>
                <p className="h6">
                    <a className="animated" href="/Division/Research/Content/">Browse our Featured Content</a>
                </p>
                <p className="h6">
                    <Link className="animated" to="/Contact">Contact Us</Link>
                </p>
                </Col>
            </Row>
            <hr className="my-4"/> 
            <Row>
                <Col sm={12}>
                    <RichText render={aboutPageInfo.about_summary.raw}/> 
                </Col>
            </Row>
            {aboutPageInfo.info_sections.map(item => (
                <Row key={item.section_title}>
                    <Col sm={12}>
                        <h2>{item.section_title}</h2>
                        <RichText render={item.section_text.raw}/> 
                    </Col>
                </Row>
            ))}
            <hr/>
            <Row>
                <Col sm={12}>
                    <h2 className="mb-4">Research Division Staff</h2>
                </Col>
                <Col lg={6}>
                    {staffLeftColumn.map(group => (
                        <div key={group.unit_name} className="my-3 staff-list">
                            <h3>{group.unit_name}</h3>
                            <RichText render={group.staff_list.raw}/> 
                        </div>
                    ))}
                </Col>
                <Col lg={6}>
                {staffRightColumn.map(group => (
                        <div key={group.unit_name} className="my-3 staff-list">
                            <h3>{group.unit_name}</h3>
                            <RichText render={group.staff_list.raw}/> 
                        </div>
                    ))}
                </Col>
            </Row>
        </Layout>
    )
    }
    else {
        return null
    }
        
}

export default About